import React, { useCallback, useContext } from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';

import { DEFAULT_DATA_ORIGIN } from '../../constants/constants';
import { PERMISSIONS_BY_ROUTE } from '../../constants/permissions';
import { CLICK_ACTION, COLLABORATORS_ENTERPRISE } from '../../constants/tagManager';
import { CompanyContext } from '../../context/company/companyContext';
import usePermissions from '../../hooks/usePermissions/usePermissions';
import { IUserCompany } from '../../interfaces/businessData';
import TagManagerService from '../../services/gtm/tagManagerService';
import { TRANSLATIONS_GLOBAL } from '../../translations/commons';
import DropdownButton from '../DropdownButton/DropdownButton';
import { IMenuPosition } from '../StyledMenu/StyledMenu';

import './styles.scss';

interface CompanySelectorProps {
  menuDirection: {
    anchor: IMenuPosition;
    transform: IMenuPosition;
  };
}
const CompanySelector = ({ menuDirection }: CompanySelectorProps) => {
  const { company, holding, setUserCompany, setUserDataOrigin } = useContext(CompanyContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { companyRole, hasAnyAccess } = usePermissions();
  const { hide } = useIntercom();
  const { t } = useTranslation();
  const handleCompanyMenu = useCallback(
    (companyData: IUserCompany) => {
      const routeName = location.pathname;
      if (!hasAnyAccess(PERMISSIONS_BY_ROUTE[routeName], companyData)) {
        navigate(companyRole.defaultRoute);
      }
      hide();
      setUserCompany(companyData);
      setUserDataOrigin(DEFAULT_DATA_ORIGIN);
      TagManagerService.pushEvent(CLICK_ACTION, COLLABORATORS_ENTERPRISE, {
        company_name: companyData.name.toUpperCase()
      });
    },
    [navigate, companyRole.defaultRoute, setUserCompany, hasAnyAccess, setUserDataOrigin, hide]
  );
  return company.id != '' ? (
    <div className="company-button">
      <div className="company-text">{`${t(TRANSLATIONS_GLOBAL.selector.company)}:`}</div>
      <DropdownButton
        currentItem={company}
        itemList={holding.companies}
        setCurrentItem={handleCompanyMenu}
        menuDirection={menuDirection}
        disabled={holding.companies.length == 1}
      />
    </div>
  ) : (
    <div className="company-button">
      <Skeleton animation="wave" variant="text" width={300}></Skeleton>
    </div>
  );
};

export default CompanySelector;
